import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { NotificationViewerComponent } from '@app/modules/dashboard/components';

@Component({
    selector: 'app-archived-notification-viewer',
    templateUrl: '../../dashboard/components/notification-viewer/notification-viewer.template.html',
    styleUrls: ['../../dashboard/components/notification-viewer/notification-viewer.style.scss'],
    animations: [
        trigger('slideUp', [transition(':leave', [animate('10ms ease-in-out', style({ height: 0 }))])]),
        trigger('fadeIn', [
            state('void', style({ opacity: 0 })),
            transition(':enter', [animate('.35s 700ms', style({ opacity: 1 }))]),
        ]),
    ],
})
export class ArchivedNotificationViewerComponent extends NotificationViewerComponent implements OnInit {
    @Input() showArchived = true;
    hasTabs = false;

    async ngOnInit(): Promise<void> {
        await this.notificationService.refetchNotifications(this.showArchived);
    }
}
